import { Component } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-reject-document-reason',
  templateUrl: './reject-document-reason.component.html',
  styleUrls: ['./reject-document-reason.component.sass'],
  imports: [FormsModule, ReactiveFormsModule],
})
export class RejectDocumentReasonComponent {
  constructor(
    private fb: FormBuilder,
    public dialogRef: DynamicDialogRef<RejectDocumentReasonComponent>
  ) {}
  isSaveButtonEnabled: boolean = false;
  maxCharacteresAllowed = 1000;
  typedCharacteres = 0;

  rejectDocumentForm = this.fb.group({
    notes: ['', Validators.required],
  });

  submit() {}

  notesTyped(event: any) {
    let value =
      this.rejectDocumentForm.controls?.notes.value?.trimStart().length ===
      undefined
        ? 0
        : this.rejectDocumentForm.controls?.notes.value?.trimStart().length;

    this.typedCharacteres = value;

    this.isSaveButtonEnabled = value > 5;
  }

  cancel() {
    this.dialogRef.close();
  }

  saveReason() {
    this.dialogRef.close({
      rejectReason: this.rejectDocumentForm.controls.notes.value,
    });
  }
}
